export const CARD_POSITION_INITIAL = 1;
export const CARD_POSITION_READ = 2;
export const CARD_POSITION_READ_FINISHED = 3;
export const CARD_POSITION_HIDDEN = 4;
